import { Download } from 'lucide-react'
import {
  Container,
  ButtonsWrapper,
  Separator,
  Button
} from './styles'
import IAQualityControl from '../IAQualityControl'
import { useSelector } from 'react-redux'
import { pdfDisponible } from '../../utils/pdfDisponible'

export function GenerateReport ({
  save,
  warningAction,
  emptyField,
  study,
  patientData,
  showClinicalTab = false,
  onTabChange,
  manualImageQuality = {},
  onManualImageQualityChange,
  enableManualQualitySelection = false,
  readOnly = false,
  isSubmittingReport = false,
  onDownloadReport
}) {
  const { evaluations } = useSelector(state => state)

  return (
    <Container>
      <IAQualityControl
        study={study || evaluations}
        patientData={patientData}
        showClinicalTab={showClinicalTab}
        onTabChange={onTabChange}
        manualImageQuality={manualImageQuality}
        onManualImageQualityChange={onManualImageQualityChange}
        enableManualQualitySelection={!readOnly && enableManualQualitySelection}
      />

      <Separator />

      <ButtonsWrapper>
        {readOnly
          ? (
            <Button
              type='primary'
              onClick={onDownloadReport}
              disabled={!(study || evaluations)?.id || !pdfDisponible(study || evaluations)}
              aria-label={pdfDisponible(study || evaluations) ? 'Descargar informe PDF' : 'Preparando PDF...'}
              title={pdfDisponible(study || evaluations) ? 'Descargar informe PDF' : 'Preparando PDF...'}
            >
              <Download size={16} />
              &nbsp;Descargar informe PDF
            </Button>
            )
          : (
            <>
              <Button type='secondary' onClick={() => warningAction('cancel')} disabled={isSubmittingReport}> Cancelar </Button>
              <Button type='secondary' onClick={save} disabled={isSubmittingReport}> Guardar y cerrar </Button>
              <Button
                type='primary'
                onClick={() => warningAction('send')}
                disabled={emptyField || isSubmittingReport}
              >
                Enviar informe
              </Button>
            </>
            )}
      </ButtonsWrapper>
    </Container>
  )
}

export default GenerateReport
